export default __webpack_public_path__ + "static/media/mark_wa.eaf1f63a.png";